import React from 'react';
import LoadginGif from '../Media/loaderv1.gif';

const Loader = () => {
  return <img style={{ height: '100%', width: '100%' }} src={LoadginGif} />;
};

export default Loader;
